export default {
    ge: '个',
    detail: '详情',
    showDetail: '查看详情',
    edit: ' 编辑',
    console: '控制台',
    amount: '数量',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    name: "名称",
    create: "新建",
    found: "创建",
    new: "新增",
    update: "编辑",
    delete: "删除",
    operation: "操作",
    confirm: "确定",
    cancel: "取消",
    public: "公有",
    private: "私有",
    searchPlaceholder: "请输入内容",
    searchProject: "输入要查找的项目",
    download: "下载",
    upload: "上传",
    close: "关闭",
    type: "类型",
    status: "状态",
    createTime: "创建时间",
    updateTime: "更新时间",
    description: "描述",
    check: "查看",
    enable: "启用",
    disable: "禁用",
    running: "运行中",
    stop: "停止",
    prevPage: "上一页",
    nextPage: "下一页",
    network: "网络",
    disk: "磁盘",
    memory: "内存",
    cpu: "CPU",
    load: "负载",
    prevStep: "上一步",
    nextStep: "下一步",
    start: "开始",
    end: "结束",
    complete: "完成",
    default: "默认",
    B: 'B',
    KB: 'KB',
    MB: 'MB',
    GB: 'GB',
    TB: 'TB',
    PB: 'PB',
    EB: 'EB',
    configuration: '配置',
    refresh: '刷新',
    yes: '是',
    no: '否',
    error: '错误',
    warning: '警告',
    info: '提示',
    success: '成功',
    buildStatus: '构建中',
    errorStatus: '错误',
    failed: '失败',
    colon: ':',
    netmask: '子网掩码',
    moreOperation: '更多操作',
    back: '返回',
    generalInfo: '基本信息',
    namePlaceholder: '请输入名称',
    cpuPlaceholder: '请输入CPU个数',
    descPlaceholder: '请输入描述内容',
    quota: '配额',
    create_time: '创建时间',
    unknown: '未知',
    paginationMsg: '共 {{total}} 条数据，当前第 {{current}} 页',
    required_item: '必填项',
    pleaseSelect: '请选择',
    operationSelect: '智能运维',
    quitLogin: '退出登录',
    copy: '复制',
    loading: '加载中',
    dialogTitlePrefix: '> > > ',
    noData: '暂无数据'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/common.js